import { render, staticRenderFns } from "./laboratoriosUrgencias.vue?vue&type=template&id=08854e54&scoped=true"
import script from "./laboratoriosUrgencias.vue?vue&type=script&lang=js"
export * from "./laboratoriosUrgencias.vue?vue&type=script&lang=js"
import style0 from "./laboratoriosUrgencias.vue?vue&type=style&index=0&id=08854e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08854e54",
  null
  
)

export default component.exports